import "antd/es/grid/style";
import _Grid from "antd/es/grid";
var _excluded = ["value", "className", "options", "onSearch", "multiple", "modalTitle", "placeHolder", "modalPlaceHolder", "clearWhenOptionsUpdated", "okButtonProps", "cancelButtonProps", "optionsUpdating"];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { SearchOutlined, LoadingOutlined, ArrowLeftOutlined } from 'iglooicon';
import Modal from '../modal';
import Input from '../input';
import CheckBox from '../checkbox';
import Typography from '../typography';
import Button from '../button';
import { LocaleContext } from '../locale';
import { useState, useContext, useEffect, useMemo } from 'react';
import './style';
import { optionsHOC } from '../utils/option-utils';

var IglooSearchBox = function IglooSearchBox(_ref) {
  var valueProp = _ref.value,
      className = _ref.className,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      onSearch = _ref.onSearch,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      modalTitle = _ref.modalTitle,
      placeHolder = _ref.placeHolder,
      modalPlaceHolder = _ref.modalPlaceHolder,
      _ref$clearWhenOptions = _ref.clearWhenOptionsUpdated,
      clearWhenOptionsUpdated = _ref$clearWhenOptions === void 0 ? false : _ref$clearWhenOptions,
      okButtonProps = _ref.okButtonProps,
      cancelButtonProps = _ref.cancelButtonProps,
      searching = _ref.optionsUpdating,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var modalTitleProps = modalTitle || formatMessage({
    id: 'Search'
  });
  var useBreakpoint = _Grid.useBreakpoint;

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setSelected = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      modalInputValue = _useState6[0],
      setModalInputValue = _useState6[1];

  useEffect(function () {
    var setFieldValue = rest.setFieldValue;

    if (clearWhenOptionsUpdated) {
      typeof setFieldValue === 'function' && setFieldValue();
    } else {
      var foundValue = options.find(function (option) {
        return Array.isArray(valueProp) ? valueProp.includes(option.value) : option.value === valueProp;
      });

      if (!foundValue && valueProp !== undefined) {
        typeof setFieldValue === 'function' && setFieldValue();
      }
    }
  }, [options]);
  useEffect(function () {
    setSelected(Array.isArray(valueProp) ? valueProp : [valueProp]);
  }, [valueProp]);

  function beginSearch() {
    onSearch && onSearch(modalInputValue);
  }

  function handleSelect(value) {
    if (multiple) {
      selected.includes(value) ? setSelected(selected.filter(function (o) {
        return o !== value;
      })) : setSelected([].concat(_toConsumableArray(selected), [value]));
    } else {
      setSelected([value]);
    }
  }

  function selectAll() {
    setSelected(options.map(function (o) {
      return o.value;
    }));
  }

  function cancelAll() {
    setSelected([]);
  }

  var mobileModalTile = function mobileModalTile() {
    return _jsxs("div", {
      className: "igloo-search-box-modal-mobile-title",
      onClick: function onClick() {
        setModalVisible(false);
        setModalInputValue('');
        onSearch && onSearch('');
      },
      children: [_jsx(ArrowLeftOutlined, {}), _jsx(Typography, {
        level: "h4",
        children: modalTitleProps || formatMessage({
          id: 'Search'
        })
      })]
    });
  };

  var DisPlayOptions = function DisPlayOptions() {
    return _jsx("div", {
      className: "igloo-search-box-modal-options",
      children: options === null || options === void 0 ? void 0 : options.map(function (o) {
        return _jsxs("div", {
          onClick: function onClick(e) {
            return handleSelect(o.value);
          },
          className: classnames('igloo-search-box-modal-select-item', _defineProperty({}, 'igloo-search-box-active-select-item', selected.includes(o.value))),
          children: [multiple && _jsx(CheckBox, {
            className: 'igloo-search-box-modal-select-item-checkbox',
            checked: selected.includes(o.value)
          }), _jsx(Typography, {
            level: 'body1',
            children: o.label
          })]
        }, o.value);
      })
    });
  }; // ...


  var inputDisplayedValue = useMemo(function () {
    return options.filter(function (o) {
      return selected.includes(o.value);
    }).map(function (o) {
      return o.label;
    }).join(',');
  }, [options, selected]);

  var modalDom = _jsxs(Modal, {
    closable: md,
    maskClosable: false,
    visible: modalVisible,
    title: md ? modalTitleProps : mobileModalTile(),
    className: classnames(md ? 'igloo-search-box-modal-container' : 'igloo-search-box-modal-container-mobile', className),
    onCancel: function onCancel() {
      setModalVisible(false);
      setModalInputValue('');
      onSearch && onSearch('');
    },
    onOk: function onOk() {
      onSearch && onSearch('');
      setModalInputValue('');
      setModalVisible(false);
      typeof rest.onChange === 'function' && valueProp !== selected && rest.onChange(multiple ? selected : selected[0]);
    },
    okText: formatMessage({
      id: 'Done'
    }),
    cancelButtonProps: cancelButtonProps,
    okButtonProps: okButtonProps,
    children: [_jsx(Input, {
      className: "igloo-search-box-modal-input",
      value: modalInputValue,
      onChange: function onChange(e) {
        return setModalInputValue(e.target.value);
      },
      placeholder: modalPlaceHolder,
      suffix: _jsx(SearchOutlined, {
        style: {
          fontSize: 24
        },
        onClick: beginSearch
      }),
      onPressEnter: beginSearch
    }), !!options.length && _jsx("div", {
      style: {
        marginBottom: 32
      }
    }), !!options.length && multiple && _jsxs("div", {
      className: 'igloo-search-box-modal-multiple-top',
      children: [_jsx(Button, {
        type: "link",
        onClick: selectAll,
        children: formatMessage({
          id: 'Select All'
        })
      }), _jsx(Button, {
        type: "link",
        onClick: cancelAll,
        children: formatMessage({
          id: 'Clear All'
        })
      })]
    }), searching ? _jsxs("div", {
      className: "igloo-search-box-searching",
      children: [_jsx(LoadingOutlined, {}), ' ', _jsx(Typography, {
        level: "body1",
        children: formatMessage({
          id: 'Searching...'
        })
      })]
    }) : options.length ? _jsx(DisPlayOptions, {}) : null]
  });

  return _jsxs("div", {
    children: [_jsx(Input, {
      placeholder: placeHolder,
      suffix: _jsx(SearchOutlined, {
        style: {
          fontSize: 24
        }
      }),
      onClick: function onClick() {
        return setModalVisible(true);
      },
      value: inputDisplayedValue
    }), modalDom]
  });
};

var SearchBox = optionsHOC(IglooSearchBox);

SearchBox.formItemPropsHandler = function (config) {
  return {};
};

export default SearchBox;